import { createContext } from 'react';
import { PaymentsGroup } from '../../types/payments';

export type CheckoutState = {
  page: number;
  totalCount: number;
  selectedPaymentsGroup: PaymentsGroup | null;
  selectedSplitPaymentsGroupId: string | null;
};

export const DEFAULT_CHECKOUT_STATE: CheckoutState = {
  page: 1,
  totalCount: 0,
  selectedPaymentsGroup: null,
  selectedSplitPaymentsGroupId: null,
};

export type CheckoutStateAction =
  | {
      type: 'SET_PAGE';
      payload: CheckoutState['page'];
    }
  | {
      type: 'SET_TOTAL_COUNT';
      payload: CheckoutState['totalCount'];
    }
  | {
      type: 'SET_SELECTED_PAYMENTS_GROUP';
      payload: CheckoutState['selectedPaymentsGroup'];
    }
  | {
      type: 'SET_SELECTED_SPLIT_PAYMENTS_GROUP_ID';
      payload: CheckoutState['selectedSplitPaymentsGroupId'];
    };

interface CheckoutContextType {
  state: CheckoutState;
  dispatch: React.Dispatch<CheckoutStateAction>;
}

const defaultContextValue: CheckoutContextType = {
  state: DEFAULT_CHECKOUT_STATE,
  dispatch: () => {},
};

export const CheckoutContext =
  createContext<CheckoutContextType>(defaultContextValue);
